<template>
	<div id="login">
		<loginform @islogin="islogin" :isloading="isloading"></loginform>
	</div>
</template>

<script>
	import loginform from 'components/loginform/loginform'
	
	import {postlogin} from 'network/login'
	
	import md5 from 'js-md5'
	
	import {mapGetters} from 'vuex'
	
	
	export default{
		name:'login',
		data(){
			return{
				isloading:false
			}
		},
		computed:{
			...mapGetters(['showuser']),
		},
		mounted() {
			if(this.showuser != null){
				this.$router.push('/User')
			}
		},
		components:{
			loginform
		},
		methods:{
			//判断登录
			islogin(name,password){
				this.isloading=!this.isloading
				if (name !=null & password!=null) {
					postlogin(name,md5(password)).then(res=>{
						if(res.data.msg=='账号或密码错误'){
							this.$notify({
								title: '警告',
								message: res.data.msg,
								type: 'warning'
							});
							this.isloading=!this.isloading
						}else{
							this.isloading=!this.isloading
							this.$store.commit('addsession',res.data.name)
							this.$notify({
								title: '成功',
								message: '欢迎回来尊敬的:'+ res.data.name+'站长',
								type: 'success'
							});
							this.$router.push('/user')
							// this.$router.push('/home')
						}
					})
				}else{
					this.isloading=!this.isloading
					this.$notify({
						title: '警告',
						message: '账号或密码不能为空！',
						type: 'warning'
					});
				}
			},
		}
	}
</script>

<style scoped>
	#login{
		background: url('https://api.ixiaowai.cn/api/api.php') no-repeat top;
		height: 100vh;
		overflow: hidden;
		background-size:100% 100%;
	}
</style>